module.exports = __webpack_public_path__ + "static/media/1.58aae57e.jpg";